import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Nenkinkikin = props => {
  return <Dropdown.Static kubunKey='nenkinkikin' {...props} />
}
